import type { SearchSortEnum } from '@iheartjane/dm-sdk';

import type {
  AlgoliaProduct,
  FilterSortOption,
  JaneSearchState,
} from '@jane/search/types';
import { FilterSortId } from '@jane/search/types';

export interface ProductSort {
  currentSort: JaneSearchState<AlgoliaProduct>['currentSort'];
  optionalFiltersString?: string;
  searchSort: SearchSortEnum;
  setCurrentSort: (
    newSort: JaneSearchState<AlgoliaProduct>['currentSort']
  ) => void;
  sortOptions: FilterSortOption[];
}

export const productSortByRecommended: FilterSortOption = {
  id: FilterSortId.Recommended,
  isDefault: true,
  label: 'Recommended',
  value: 'by-recommendation-ordinal-asc-',
};

export const productSortByDefault: FilterSortOption = {
  id: FilterSortId.Default,
  isDefault: false,
  label: 'Featured',
  value: '',
};
export const productSortAlphabetically: FilterSortOption = {
  id: FilterSortId.AZ,
  isDefault: false,
  label: 'A-Z',
  value: '',
};
export const productSortByRating: FilterSortOption = {
  id: FilterSortId.Rating,
  isDefault: false,
  label: 'Rating',
  value: 'by-rating-',
};
export const productSortByLowestPrice: FilterSortOption = {
  id: FilterSortId.PriceAsc,
  isDefault: false,
  label: 'Lowest Price',
  value: 'by-price-',
};
export const productSortByHighestPrice: FilterSortOption = {
  id: FilterSortId.PriceDesc,
  isDefault: false,
  label: 'Highest Price',
  value: 'by-price-desc-',
};
export const productSortByLowestThc: FilterSortOption = {
  id: FilterSortId.ThcAsc,
  isDefault: false,
  label: 'Lowest THC %',
  value: 'by-thc-potency-asc-',
};
export const productSortByHighestThc: FilterSortOption = {
  id: FilterSortId.ThcDesc,
  isDefault: false,
  label: 'Highest THC %',
  value: 'by-thc-potency-desc-',
};
